import { IPartyForUser, IPartyStageForUser } from '../PartyClientResponse';
import { Tooltip } from 'antd';
import React, { useState } from 'react';
import { useVideoController } from '../controller/video/VideoControlContext';
import { useAppState } from '../state/AppState';
import Modal from './common/Modal';
import UserAvatar from './common/UserAvatar';
import EditUserInfo from './EditUserInfo';
import { SELF_VIDEO_SIZE_PX } from './party/AppConstants';
import HostControls from './party/host/HostControls';
import SelectAV from './SelectAV';

const UserControls = ({
  stage,
  debug,
  party,
  localTimestamp,
  addFakeUser,
}: {
  stage: IPartyStageForUser;
  debug: boolean;
  party: IPartyForUser;
  localTimestamp: number;
  addFakeUser: () => void;
}) => {
  const { isAudioInputBlocked, setAudioInputBlocked, localVideoEnabled, setLocalVideoEnabled } =
    useVideoController();
  const { user } = useAppState();
  const { needsAVForArea, isAudioForceMuted, isVideoForceMuted, avPermission } =
    useVideoController();
  const [isAvOpen, setIsAvOpen] = useState<boolean>(false);
  const [isEditUserOpen, setIsEditUserOpen] = useState<boolean>(false);
  const [isFaqOpen, setIsFaqOpen] = useState<boolean>(false);

  // const currentParticipant =
  //   (user && stage && stage.participants && stage.participants[user.uid as TUserId]) || null;
  // const isHost = user?.isAdmin || currentParticipant?.tags?.includes('host');

  return (
    <div style={{ display: 'flex', alignSelf: 'flex-start', flexDirection: 'column' }}>
      <Modal isOpen={isAvOpen}>
        <div className='onboarding-card'>
          <SelectAV onComplete={() => setIsAvOpen(false)} />
        </div>
      </Modal>
      <Modal isOpen={isEditUserOpen}>
        <div className='onboarding-card'>
          <EditUserInfo onClose={() => setIsEditUserOpen(false)} />
        </div>
      </Modal>
      <Tooltip
        title={
          avPermission === 'denied'
            ? 'Error: webcam permission denied. Give webcam and mic access to use video.'
            : 'This is you. Click to personalize your settings'
        }
        arrowPointAtCenter
        mouseEnterDelay={1}
        placement='bottom'>
        <div
          style={{
            display: 'flex',
            cursor: 'pointer',
            justifyContent: 'flex-end',
            marginBottom: 10,
          }}
          onClick={() => setIsEditUserOpen(true)}>
          <div className='user-controls-name'>
            <div>{user?.displayName || 'Anonymous User'}</div>
          </div>
          <div style={{ display: 'flex', position: 'relative' }}>
            <div style={{ width: SELF_VIDEO_SIZE_PX, height: SELF_VIDEO_SIZE_PX }}>
              <UserAvatar
                size={SELF_VIDEO_SIZE_PX}
                style={{
                  border: '1px solid #faf7f8',
                  boxShadow: '0px 0px 20px #00000061',
                  // position: 'absolute',
                  width: '100%',
                  height: '100%',
                }}
              />
            </div>
            {/* <SelfVideoBubble /> */}
            {/* <VideoWithRef
            key={`self-video`}
            srcObject={localStream || null}
            autoPlay={true}
            muted
            style={{
              width: 48,
              height: 48,
              transform: 'scaleX(-1)',
              border: '1px solid rgb(250, 247, 248)',
              boxShadow: 'rgba(0, 0, 0, 0.38) 0px 0px 20px',
            }}
          /> */}
          </div>
        </div>
      </Tooltip>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <HostControls
          addFakeUser={addFakeUser}
          debug={debug}
          stage={stage}
          party={party}
          localVideoTimestamp={localTimestamp}
        />
        <Tooltip arrowPointAtCenter title='Change my audio/video settings' placement='bottom'>
          <div
            className={`floating-control-button info ${!needsAVForArea ? 'disabled' : ''}`}
            onClick={(e) => {
              setIsAvOpen(true);
            }}>
            <img alt='settings' src='/icons/settings_user.svg' width={40} height={40}></img>
          </div>
        </Tooltip>
        <Tooltip
          arrowPointAtCenter
          title={localVideoEnabled ? 'Disable your webcam' : 'Enable your webcam'}
          placement='bottom'>
          <div
            className={`floating-control-button ${isVideoForceMuted ? 'force-muted' : ''} ${!needsAVForArea ? 'disabled' : ''}`}
            onClick={(e) => {
              if (!isVideoForceMuted) {
                setLocalVideoEnabled(!localVideoEnabled);
              }
            }}>
            {localVideoEnabled ? (
              <img alt='camera' src='/icons/camera.svg' width={40} height={40}></img>
            ) : (
              <img alt='camera' src='/icons/camera_off.svg' width={40} height={40}></img>
            )}
          </div>
        </Tooltip>
        <Tooltip
          arrowPointAtCenter
          title={isAudioInputBlocked ? 'Enable your microphone' : 'Disable your microphone'}
          placement='bottom'>
          <div
            className={`floating-control-button ${isAudioForceMuted ? 'force-muted' : ''} ${!needsAVForArea ? 'disabled' : ''}`}
            onClick={() => {
              if (!isAudioForceMuted) {
                setAudioInputBlocked(!isAudioInputBlocked);
              }
            }}>
            {isAudioInputBlocked ? (
              <img alt='mic' src='/icons/mic_off.svg' width={40} height={40}></img>
            ) : (
              <img alt='mic' src='/icons/mic.svg' width={40} height={40}></img>
            )}
          </div>
        </Tooltip>
        <Tooltip arrowPointAtCenter title='Read the FAQ' placement='bottom'>
          <a href='/b/faq' target='_blank'>
            <div className='floating-control-button info'>
              <img alt='settings' src='/icons/help.svg' width={40} height={40}></img>
            </div>
          </a>
        </Tooltip>
      </div>
    </div>
  );
};

export default UserControls;
